import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { Helmet } from 'react-helmet-async';
import './Services.css';

const services = [
    {
        id: 1,
        title: "Online Reputation Management",
        description: "Is your business represented fairly online? Don't let a single negative comment ruin your reputation. We offer custom reputation management services to help you get more reviews and streamline your brand perception.",
        focus: ["Review Generation", "Brand Protection", "Trust Building"],
        icon: "ri-shield-star-line",
        cta: "Protect Your Brand",
        image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&q=80&w=800"
    },
    {
        id: 2,
        title: "Website Design & Development with AI Integrations",
        description: "Creative and professional web design solutions that achieve maximum exposure. Our experienced team of designers and developers cater to your specific business needs, offering budget-friendly yet premium quality services.",
        focus: ["Custom Design & Coding", "User Experience (UX)", "With AI Automations"],
        icon: "ri-layout-masonry-line",
        cta: "Start A Project",
        image: "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?auto=format&fit=crop&q=80&w=800"
    },
    {
        id: 3,
        title: "Comprehensive Ecommerce Solutions",
        description: "Strategy and execution for companies that need their investment in marketing to drive scalable business growth. We specialize in SEO, targeted ad campaigns, and store management to build programs that drive better lead acquisition, engagement, and nurturing.",
        focus: ["SEO & Organic Growth", "Targeted Ad Campaigns", "Conversion & Store Management"],
        icon: "ri-shopping-bag-3-line",
        cta: "Scale Your Store",
        image: "https://images.unsplash.com/photo-1661956602116-aa6865609028?auto=format&fit=crop&q=80&w=800"
    }
];

const Services = ({ user }) => {
    const navigate = useNavigate();

    useEffect(() => {
        // window.scrollTo(0, 0);
    }, []);

    return (
        <div className="services-page">
            <Helmet>
                <title>Our Services - Collaboration World</title>
                <meta name="description" content="Explore our comprehensive digital solutions including online reputation management, ecommerce growth, and custom website design." />
                <link rel="canonical" href="https://www.collaborationworld.in/services" />
            </Helmet>

            <Navbar user={user} />

            <header className="services-hero">
                <div className="hero-content">
                    <span className="subtitle">OUR EXPERTISE</span>
                    <h1>Comprehensive Digital<br />Solutions</h1>
                    <p>Tailored strategies to drive growth, elevate your brand, and secure your digital legacy.</p>
                </div>
            </header>

            <main className="services-list">
                {services.map((service, index) => (
                    <section key={service.id} className="service-block">
                        <div className="service-content">
                            <span className="service-number">0{index + 1}</span>
                            <h2 className="service-title">{service.title}</h2>
                            <p className="service-desc">{service.description}</p>

                            <div className="service-features">
                                <h3>Key Focus</h3>
                                <ul>
                                    {service.focus.map((item, i) => (
                                        <li key={i}><i className="ri-check-line"></i> {item}</li>
                                    ))}
                                </ul>
                            </div>

                            <button onClick={() => navigate('/contact')} className="btn-service-action">
                                {service.cta} <i className="ri-arrow-right-line"></i>
                            </button>
                        </div>

                        <div className="service-visual-wrapper">
                            <div className="service-image">
                                <img src={service.image} alt={service.title} />
                                <div className="image-overlay"></div>
                            </div>
                        </div>
                    </section>
                ))}
            </main>

            <Footer />
        </div>
    );
};

export default Services;
